// Lot / Parti listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.lots';

export const inventoryLotsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Lotlar nasıl takip edilir?'),
  intro: t(`${G}.intro`, 'Bu ekran, lot (parti) takibi yapılan ürünlerin stoktaki partilerini, son kullanma tarihlerini ve hareketlerini gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, 'Mutabakat ve Ayarlar'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Lot listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Lotu bulun'),
      text: t(`${G}.s1.text`, 'Arama kutusuna lot no, tedarikçi parti no, ürün adı veya stok kodu yazın. "Durum" ile Aktif ya da Bloke lotları, "Son kullanma" ile tarihe göre süzün. Listede yalnız stokta miktarı kalan lotlar görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Süresi geçmiş: son kullanma tarihi bugünden önce olanlar.'),
        t(`${G}.s1.tip2`, 'Yaklaşan: tarihi bugün ile Ayarlar\'daki "Yaklaşan gün sayısı" (varsayılan 30 gün) arasında olanlar.'),
        t(`${G}.s1.tip3`, 'Tarihsiz: son kullanma tarihi girilmemiş lotlar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Listeyi ve kalan gün rengini okuyun'),
      text: t(`${G}.s2.text`, 'Her satırda lot no, ürün, SKT (son kullanma tarihi), Bakiye (lottaki toplam miktar), lotun bulunduğu depo sayısı, kaynak ve durum yer alır. SKT\'nin yanındaki etiket kaç gün kaldığını gösterir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kırmızı: süresi geçmiş (kalan gün eksi).'),
        t(`${G}.s2.tip2`, 'Turuncu: 30 gün veya daha az kaldı.'),
        t(`${G}.s2.tip3`, 'Gri: 30 günden fazla var.'),
        t(`${G}.s2.tip4`, 'Durum: ACTIVE aktif, HOLD bloke demektir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Lot detayını açın ve düzenleyin'),
      text: t(`${G}.s3.text`, 'Bir satıra tıklayınca sağda lot detayı açılır: bakiye, kaynak, depo bazında miktarlar ve "İşlem geçmişi" (tarih, yön, miktar, tür). "Düzenle" ile tedarikçi parti no, üretim tarihi, son kullanma tarihi ve notu değiştirip "Kaydet" deyin.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Gerekirse lotu bloke edin'),
      text: t(`${G}.s4.text`, 'Sorunlu bir partiyi satıştan çekmek için detaydaki "Not" alanına nedeni yazıp "Bloke et" deyin. Bloke lot faturada kullanılamaz; kullanılmak istenirse kayıt "lot bloke" uyarısıyla durdurulur. Sorun çözülünce "Bloğu kaldır" ile tekrar aktif yapın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Üretimde kalite kontrolü başarısız olursa ilgili lotlar sistem tarafından otomatik bloke edilebilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. İzlenebilirlik ve geri çağırma'),
      text: t(`${G}.s5.text`, '"İzlenebilirlik" sekmesinde "Geriye" lotun hangi lotlardan üretildiğini, "İleriye" hangi lotlara kullanıldığını ağaç olarak gösterir. "Geri çağırma" sekmesi bu lotun ve ondan üretilen lotların çıkış yaptığı carileri, miktar ve belge sayısıyla listeler; "Excel indir" ile bu listeyi dışa alırsınız.'),
      tips: [
        t(`${G}.s5.tip1`, 'Ağaç en fazla 10 seviye gösterilir; daha derinse kesildiği belirtilir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Mutabakat ve ayarlar'),
      text: t(`${G}.s6.text`, '"Mutabakat" her ürün ve depo için depo stoğu ile lot toplamını karşılaştırır, farkları gösterir. "Eşitle" lot bakiyelerini depo stoğuna denkler: fazla stok "MUTABAKAT" adlı bir lota alınır, eksik kısım lotlardan düşülür. Depo stok miktarı değişmez.'),
      tips: [
        t(`${G}.s6.tip1`, 'Ayarlar: lot numarası deseni (önizlemesiyle), "Yaklaşan gün sayısı" ve süresi geçmiş lotun üretimde / satışta kullanılmasını engelleyen anahtarlar.'),
        t(`${G}.s6.tip2`, '"Satışta süresi geçmiş lotu kullanma" açıksa, süresi geçmiş lot faturaya girilemez.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin; sayfa başına 20, 50 veya 100 satır seçebilirsiniz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
